/**
 * @deprecated Use IRoleAssignment instead.
 * Kept for backward compatibility with existing guards and nav filtering.
 * SystemAdmin is still used for admin-only route gating.
 */
export enum UserRole {
    Initiator = 'Initiator',
    Reviewer = 'Reviewer',
    Approver = 'Approver',
    SystemAdmin = 'SystemAdmin'
}

export const UserRoleLabel: Record<UserRole, string> = {
    [UserRole.Initiator]: 'معد',
    [UserRole.Reviewer]: 'مراجع',
    [UserRole.Approver]: 'معتمد',
    [UserRole.SystemAdmin]: 'مدير النظام'
};